<template>
  <v-toolbar app fixed clipped-left>
    <v-toolbar-side-icon @click.stop="openMenu"></v-toolbar-side-icon>
    <v-toolbar-title>
      {{ AppState.title }}
      <div class="subheading" v-text="subtitle"></div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    
    <v-tooltip bottom>
      <v-btn icon @click.stop="setView('Desktop')" slot="activator"> <v-icon>desktop_windows</v-icon> </v-btn>
      <span>Switch to Desktop view</span>
    </v-tooltip>
    <v-tooltip bottom>
      <v-btn icon @click.stop="setView('Mobile')" slot="activator"> <v-icon>smartphone</v-icon> </v-btn>
      <span>Switch to Mobile view</span>
    </v-tooltip>
    <v-tooltip bottom>
      <v-btn icon @click.stop="setView('FbTab')" slot="activator"> <v-icon>fa-facebook-official</v-icon> </v-btn>
      <span>Switch to Facebook Tab view</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <div class="text-xs-right">
      <v-btn icon @click.stop="saveTemp" class="mr-5"> Save </v-btn>
      <v-btn icon @click.stop="loadTemp" class="mr-5"> Load </v-btn>
      <v-btn icon @click.stop="publish" class="mr-5"> Publish </v-btn>
      <v-btn dark fab class="accent" @click.stop="openSideMenu"> <v-icon>add</v-icon> </v-btn>
    </div>
  </v-toolbar>
</template>

<script>
import AppState from "../util/AppState";
import bus from "../util/bus";

export default {
  props: ["view"],
  data() {
    return {
      AppState
    };
  },
  computed: {
    subtitle() {
      return `${AppState.currentProject.title} - ${AppState.currentPage.title}`;
    }
  },
  methods: {
    openMenu() {
      this.$emit("openMenu");
    },
    openSideMenu() {
      this.$emit("openSideMenu");
    },
    setView(v) {
      this.$emit("setView", v);
    },
    publish() {
      bus.$emit("publish");
    },
    saveTemp() {
      bus.$emit("saveTemp");
    },
    loadTemp() {
      bus.$emit("loadTemp");
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue